import { render, staticRenderFns } from "./TotalSessionData.vue?vue&type=template&id=72648f4f&"
import script from "./TotalSessionData.vue?vue&type=script&lang=js&"
export * from "./TotalSessionData.vue?vue&type=script&lang=js&"
import style0 from "./TotalSessionData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports